/**
 * Created by Jew on 1/3/2018.
 */
import {Component, Inject, ViewChild} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {IdexService} from 'app/idex.service';
import {LoadingButtonComponent} from 'app/shared/loading-button/button';
import {Toast} from '../../shared/toast/toast';

@Component({
   selector: 'app-change-avatar',
   templateUrl: 'change-avatar.component.html',
   styleUrls: ['change-avatar.component.css']
})
export class ChangeAvatarComponent {
   @ViewChild('ok') button: LoadingButtonComponent;
   imageData: any;
   avatar: File;
   size = 2097152;

   constructor(private dialogRef: MatDialogRef<ChangeAvatarComponent>,
               @Inject(MAT_DIALOG_DATA) private data: any, private service: IdexService, private toast: Toast) {
   }

   selectAvatar(event: any) {
      const imageType = /image\/jpg|png|jpeg/;
      if (event.target.files && !event.target.files[0].type.match(imageType) || event.target.files[0].size > this.size) {
         this.data.translate.get('alert.avatar_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      if (event.target.files && event.target.files[0] && event.target.files[0].size < this.size) {
         this.avatar = event.target.files[0];
         this.loadPreview();
      }
   }

   changeAvatar() {
      this.service.updateAvatar(this.avatar)
         .subscribe(data => {
            this.dialogRef.close();
            this.data.updateAvatar(data);
         }, () => {
            this.button.reset();
         });
   }

   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items && data.items.length === 1) {
         const imageType = /image\/jpg|png|jpeg/;
         if (data.items[0].type.match(imageType)) {
            hasFiles = true;
         }
      }
      if (hasFiles) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
      }
   }

   onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      if (event.dataTransfer.items[0].getAsFile().size > this.size) {
         this.data.translate.get('alert.avatar_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      if (event.dataTransfer && event.dataTransfer.items[0].getAsFile()) {
         this.avatar = event.dataTransfer.items[0].getAsFile();
         this.loadPreview();
      }
   }

   private loadPreview() {
      const reader = new FileReader();
      reader.onload = (e: any) => {
         this.imageData = e.target.result;
      };
      reader.readAsDataURL(this.avatar);
   }
}
